<div [ngClass]="['py-3', field.key]">
  <!-- label -->
  @if (!field.hasOwnLabel && !field.isLabelHidden) {
  <pax-form-field-label
    [key]="field.key"
    [label]="field.label"
    [subLabel]="field.subLabel"
    [helpDialog]="field.helpDialog"
    [labelClasses]="field.labelClassName"
    (openDialog)="openDialog()"
  />
  }
  <div>
    <!-- Always visible (short) info -->
    @if (field.infoText) {
    <div class="mb-2 px-1 text-sm">{{ field.infoText }}</div>
    }

    <!-- Dynamic Input -->
    <div>
      <ng-template paxFormFieldInput></ng-template>
    </div>

    <!-- Error message -->
    @if (control.invalid && control.touched) {
    <div class="text-sm text-error" [attr.data-testid]="errorMessageTestId">
      {{ localizedErrorMessages(control.errors) }}
    </div>
    }
  </div>
</div>
